import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import AnimatedPromoBanner from './components/AnimatedPromoBanner';
import ProductCategories from './components/ProductCategories';
import FeaturedProducts from './components/FeaturedProducts';
import BlogSection from './components/BlogSection';
import Footer from './components/Footer';
import HomePromoSection from './components/HomePromoSection';
import SeoHead, { SITE_URL } from '@/components/feature/SeoHead';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'NeonPharma',
    url: SITE_URL,
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Pharmacy',
    name: 'NeonPharma',
    description: 'Интернет-аптека нового поколения с японскими формулами здоровья. Более 10 000 товаров, доставка за 2 часа, работаем 24/7.',
    url: SITE_URL,
    telephone: '+74996536277',
    openingHours: 'Mo-Su 00:00-24:00',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'ул. Ивана Франко, д. 8',
      addressLocality: 'Москва',
      postalCode: '121108',
      addressCountry: 'RU',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 55.7441,
      longitude: 37.3897,
    },
    priceRange: '₽₽',
    hasMap: 'https://maps.google.com/?q=Москва,+ул.+Ивана+Франко,+д.+8',
  },
];

const HomePage = () => {
  return (
    <div className="min-h-screen" style={{ background: '#050508' }}>
      <SeoHead
        title="NeonPharma — Интернет-аптека нового поколения | Японские формулы здоровья"
        description="NeonPharma — интернет-аптека с японскими формулами здоровья. Более 10 000 товаров, доставка за 2 часа, работаем 24/7. Витамины, БАД, уход за кожей, обезболивающие по лучшим ценам."
        keywords="интернет-аптека, японские препараты, витамины, БАД, доставка лекарств, NeonPharma"
        canonical="/"
        ogType="website"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <HeroBanner />
      <AnimatedPromoBanner />
      <HomePromoSection />
      <ProductCategories />
      <FeaturedProducts />
      <BlogSection />
      <Footer />
    </div>
  );
};

export default HomePage;
